export default {
    zhCNIndex: {
        A: [
            "AL",
            "DZ",
            "AF",
            "AR",
            "EH",
            "AE",
            "AW",
            "OM",
            "AZ",
            "IE",
            "EG",
            "ET",
            "EE",
            "AD",
            "AO",
            "AI",
            "AG",
            "AU",
            "AT",
            "AX"
        ],
        B: [
            "BB",
            "PG",
            "BS",
            "PK",
            "PY",
            "PS",
            "BH",
            "PA",
            "BR",
            "BY",
            "BM",
            "BG",
            "MP",
            "MK",
            "BJ",
            "BE",
            "PE",
            "IS",
            "BW",
            "PR",
            "BA",
            "PL",
            "BO",
            "BZ",
            "BT",
            "BF",
            "BI",
            "BV"
        ],
        C: ["KP", "GQ"],
        D: ["DK", "DE", "TL", "TG", "DO", "DM"],
        E: ["EC", "ER", "RU"],
        F: ["FR", "FO", "PF", "GF", "TF", "MF", "VA", "FJ", "PH", "FI", "CV", "FK"],
        G: ["GM", "CG", "CD", "GD", "GL", "GE", "CO", "CR", "GG", "CU", "GP", "GU", "GY"],
        H: ["KZ", "HT", "KR", "HM", "NL", "BQ", "SX", "ME", "HN"],
        J: ["DJ", "KG", "KI", "GN", "GW", "GH", "CA", "GA", "KH", "CZ", "ZW"],
        K: ["CM", "QA", "KY", "CC", "HR", "KM", "XK", "CI", "KW", "KE", "CK", "CW"],
        L: ["LV", "LS", "LA", "LB", "LR", "LY", "LT", "LI", "RE", "LU", "RW", "RO"],
        M: [
            "MG",
            "IM",
            "MV",
            "MT",
            "MW",
            "MY",
            "ML",
            "MH",
            "MQ",
            "YT",
            "MU",
            "MR",
            "US",
            "UM",
            "AS",
            "VI",
            "MN",
            "BD",
            "MS",
            "FM",
            "MM",
            "MD",
            "MA",
            "MC",
            "MZ",
            "MX"
        ],
        N: ["NA", "ZA", "AQ", "GS", "SS", "NR", "NI", "NP", "NE", "NG", "NU", "NF", "NO"],
        P: ["PW", "PN", "PT"],
        R: ["JP", "SE", "CH"],
        S: [
            "SV",
            "WS",
            "RS",
            "SL",
            "SN",
            "CY",
            "SC",
            "SA",
            "BL",
            "CX",
            "ST",
            "SH",
            "KN",
            "LC",
            "SM",
            "PM",
            "VC",
            "LK",
            "SK",
            "SI",
            "SJ",
            "SZ",
            "SD",
            "SR",
            "SB",
            "SO"
        ],
        T: ["TJ", "TH", "TZ", "TO", "TC", "TT", "TR", "TM", "TN", "TV", "TK"],
        W: ["WF", "VU", "GT", "VE", "BN", "UG", "UA", "UY", "UZ"],
        X: ["ES", "GR", "SG", "NC", "NZ", "HU", "SY"],
        Y: ["JM", "AM", "YE", "IT", "IQ", "IR", "IL", "IN", "ID", "GB", "VG", "IO", "JO", "VN"],
        Z: ["ZM", "JE", "TD", "GI", "CL", "CF", "CN", "MO", "TW", "HK"]
    },
    enUSIndex: {
        A: ["AF", "AX", "AL", "DZ", "AS", "AD", "AO", "AI", "AQ", "AG", "AR", "AM", "AW", "AU", "AT", "AZ"],
        B: [
            "BS",
            "BH",
            "BD",
            "BB",
            "BY",
            "BE",
            "BZ",
            "BJ",
            "BM",
            "BT",
            "BO",
            "BA",
            "BW",
            "BV",
            "BR",
            "IO",
            "BN",
            "BG",
            "BF",
            "BI",
            "BQ"
        ],
        C: [
            "KH",
            "CM",
            "CA",
            "CV",
            "KY",
            "CF",
            "TD",
            "CL",
            "CN",
            "CX",
            "CC",
            "CO",
            "KM",
            "CK",
            "CR",
            "CI",
            "HR",
            "CU",
            "CY",
            "CZ",
            "CW"
        ],
        R: ["CG", "GM", "RE", "RO", "RU", "RW"],
        D: ["CD", "DK", "DJ", "DM", "DO"],
        E: ["EC", "EG", "SV", "GQ", "ER", "EE", "ET", "SZ"],
        F: ["FK", "FO", "FJ", "FI", "FR", "GF", "PF", "TF"],
        G: ["GA", "GE", "DE", "GH", "GI", "GR", "GL", "GD", "GP", "GU", "GT", "GN", "GW", "GY", "GB", "GG"],
        H: ["HT", "HM", "VA", "HN", "HK", "HU"],
        I: ["IS", "IN", "ID", "IR", "IQ", "IE", "IL", "IT", "IM"],
        J: ["JM", "JP", "JO", "JE"],
        K: ["KZ", "KE", "KI", "KW", "KG", "XK"],
        N: ["KP", "NA", "NR", "NP", "NL", "NC", "NZ", "NI", "NE", "NG", "NU", "NF", "MK", "MP", "NO"],
        S: [
            "KR",
            "SH",
            "KN",
            "LC",
            "PM",
            "VC",
            "WS",
            "SM",
            "ST",
            "SA",
            "SN",
            "SC",
            "SL",
            "SG",
            "SK",
            "SI",
            "SB",
            "SO",
            "ZA",
            "GS",
            "ES",
            "LK",
            "SD",
            "SR",
            "SJ",
            "SE",
            "CH",
            "SY",
            "BL",
            "MF",
            "RS",
            "SX",
            "SS"
        ],
        L: ["LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT", "LU"],
        M: [
            "MO",
            "MG",
            "MW",
            "MY",
            "MV",
            "ML",
            "MT",
            "MH",
            "MQ",
            "MR",
            "MU",
            "YT",
            "MX",
            "FM",
            "MD",
            "MC",
            "MN",
            "MS",
            "MA",
            "MZ",
            "MM",
            "ME"
        ],
        O: ["OM"],
        P: ["PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PN", "PL", "PT", "PR"],
        Q: ["QA"],
        T: ["TW", "TJ", "TZ", "TH", "TL", "TG", "TK", "TO", "TT", "TN", "TR", "TM", "TC", "TV"],
        U: ["UG", "UA", "AE", "US", "UM", "UY", "UZ"],
        V: ["VU", "VE", "VN", "VG", "VI"],
        W: ["WF", "EH"],
        Y: ["YE"],
        Z: ["ZM", "ZW"]
    }
};
